import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  List,
  ListItem,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import { IExceededLimit } from "../types/menuBuilder.types";

interface ILimitOverrideDialogProps {
  open: boolean;
  exceededLimits: IExceededLimit[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const LimitOverrideDialog: React.FC<ILimitOverrideDialogProps> = ({
  open,
  exceededLimits,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Limit Exceeded Warning</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          The following categories or subcategories have exceeded their
          configured selection limits. You can still proceed with the save if
          this is intentional.
        </DialogContentText>
        <Box sx={{ maxHeight: 300, overflow: "auto" }}>
          <List disablePadding>
            {exceededLimits.map((limit, index) => (
              <ListItem
                key={`${limit.name}-${index}`}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  py: 1,
                  px: 2,
                  borderBottom:
                    index < exceededLimits.length - 1
                      ? "1px solid"
                      : "none",
                  borderColor: "divider",
                }}
              >
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "error.main" }}
                  >
                    {limit.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {limit.type}
                  </Typography>
                </Box>
                <Chip
                  label={`${limit.current}/${limit.max}`}
                  color="error"
                  size="small"
                  variant="outlined"
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Proceed Anyway
        </Button>
      </DialogActions>
    </Dialog>
  );
};
